module.exports = __webpack_public_path__ + "img/PowerOfTakt-TaktControlThree.93d76841.png";